import React from "react";
import ReactDOM from "react-dom";

import "./styles.css";

function App() {
  return (
    <div className="App">
      <h1>Simply Split Support</h1>
      <h2>Need help?</h2>
      Send me an email at dleemsmule2@gmail.com and I will get back to you as soon as possible!
    </div>
  );
}

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
